// Shared network + contact data for the Rexxpons ecosystem footer/top bar.

export const NETWORK_URL = "https://www.rexxponsnetwork.online";

export const NETWORK_APPS = [
  { name: "Rexxpons Browser", url: "https://www.nexxaris.com" },
  { name: "Rating — Analisi di bilancio con business plan integrato", url: "https://www.ratingonline.store" },
  { name: "Business Plan per Start-up", url: "https://www.businessplan-online.store" },
  { name: "Certytrace Due Diligence", url: "https://www.certytrace.store" },
  { name: "Reputazione Rapida", url: "https://www.reputazione.shop" },
  { name: "Rexxengine — Motore di ricerca cognitivo", url: "https://www.rexxengine.store" },
  { name: "Rexx Legal", url: "https://www.rexxlegal.store" },
  { name: "Rexx Legal Assistent", url: "https://www.rexxlegalassistent.online" },
  { name: "Rexx Calling", url: "https://www.rexxcalling.com" },
];

export const CONTACTS = {
  firm: "Galano & Partners Law Firm",
  address: "Piazza Malta 21, Salerno, Italy",
  telDisplay: "+39 349 9592959",
  telHref: "tel:+393499592959",
  email: "avv.luigigalano@pec.it",
  emailHref: "mailto:avv.luigigalano@pec.it",
  whatsappDisplay: "+39 340 9592059",
  whatsappHref: "https://wa.me/393409592059",
};

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
